import { AxiosPromise } from 'axios';
import {
    ContactTag,
    CreateContactTagRequest,
    UpdateContactTagRequest,
} from '../../types/ContactTag';
import { libApiInstance } from '../axios';

export function requestAllTags(signal?: AbortSignal): AxiosPromise<ContactTag[]> {
    return libApiInstance.get('/contacts/tags', { signal });
}

export function requestTagById(tagId: number, signal?: AbortSignal): AxiosPromise<ContactTag> {
    return libApiInstance.get(`/contacts/tags/${tagId}`, { signal });
}

export function requestContactTags(
    contactId: number,
    signal?: AbortSignal,
): AxiosPromise<ContactTag[]> {
    return libApiInstance.get(`/contacts/${contactId}/tags`, { signal });
}

export function requestCreateContactTag(
    data: CreateContactTagRequest,
    signal?: AbortSignal,
): AxiosPromise<number> {
    return libApiInstance.post('/contacts/tags', data, { signal });
}

export function requestUpdateContactTag(
    tagId: number,
    data: UpdateContactTagRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put(`/contacts/tags/${tagId}`, data, { signal });
}

export function requestDeleteContactTag(
    tagId: number,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/tags/${tagId}`, { signal });
}

export function requestAssignContactTag(
    tagId: number,
    contactIds: number[],
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.put(`/contacts/tags/${tagId}/items`, contactIds, {
        signal,
    });
}

export function requestUnassignContactTag(
    tagId: number,
    contactIds: number[],
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.delete(`/contacts/tags/${tagId}/items`, {
        signal,
        data: contactIds,
    });
}
